var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"py-3 align-end"},[_c('v-col',{attrs:{"cols":"12","lg":_vm.boxesLgCols}},[_vm._t("boxes")],2),_c('v-col',{attrs:{"cols":"12","lg":_vm.buttonsLgCols}},[_c('v-row',{staticClass:"px-2"},[_c('v-col',{staticClass:"d-flex flex-column",attrs:{"cols":"12"}},[_vm._t("buttons")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }